import { ActionTypes } from '../actions';

const initialState = {
  all: [],
  current: {},
};

const ChaptersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_CHAPTERS:
      return { all: action.payload, current: state.current };
    case ActionTypes.FETCH_CHAPTER:
      return { all: state.all, current: action.payload };
    default:
      return state;
  }
};

export default ChaptersReducer;
